import { render, staticRenderFns } from "./bookinfoRepository.vue?vue&type=template&id=6a6d1818&scoped=true&"
import script from "./bookinfoRepository.vue?vue&type=script&lang=js&"
export * from "./bookinfoRepository.vue?vue&type=script&lang=js&"
import style0 from "./bookinfoRepository.vue?vue&type=style&index=0&id=6a6d1818&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a6d1818",
  null
  
)

export default component.exports